/**
 * Created by georgehupeijie on 2018/5/28.
 * options传入maxCount, interval时，最大polling次数为maxCount，间隔时间为interval
 * 没有传入maxCount, interval时，由前端控制polling机制
 */

// polling超时时间
const BOUNDARY_LV1 = 10 * 1000;
const BOUNDARY_LV2 = 30 * 1000;
const TIME_OUT = 60 * 1000;

// 不同等级polling时间间隔
const LV1_GAP = 1000;
const LV2_GAP = 3 * 1000;
const LV3_GAP = 5 * 1000;

const Polling = function(options) {
  let pollingCount = 0;
  let startTime = new Date();
  let timeoutId = '';
  let active = true;

  function polling() {
    if (!active)return;
    if (options.maxCount && options.maxCount === pollingCount) {
      options.timeout && options.timeout();
      return;
    }
    pollingCount++;
    options.promise(options.args, options.extraArgs)
      .then(res => {
        if (!active)return;
        if (res.message && res.message.length > 0) {
          options.finished && options.finished(res.result, res.message);
        } else {
          let time = 0;
          if (options.interval !== undefined) {
            time = options.interval;
          } else {
            if (new Date() - startTime <= BOUNDARY_LV1) {
              time = LV1_GAP;
            } else if (new Date() - startTime <= BOUNDARY_LV2) {
              time = LV2_GAP;
            } else if (new Date() - startTime <= TIME_OUT) {
              time = LV3_GAP;
            }
          }
          if (time) {
            options.working && options.working(res.result, res.message);
            timeoutId = setTimeout(polling, time);
          } else {
            options.timeout && options.timeout();
          }
        }
      }).catch(e => {
      timeoutId && clearTimeout(timeoutId);
      options.failed && options.failed(e);
    })
  }

  return {
    start(){
      active = true;
      options.beforeCreated();
      polling();
    },
    stop(){
      active = false;
      timeoutId && clearTimeout(timeoutId);
    }
  }
}


export default Polling;
